import Message from 'owa-service/lib/contract/Message';
import { RecipientsCollection } from 'owa-attachment-well-data/lib/utils/includeMostRecentAttachmentsInfoBarMessage';

export default function getRelativeComplementOfComposeRecipients(
    recipients: RecipientsCollection,
    message: Message
): string[] {
    const messageRecipients: string[] = getUniqueEmailAddressesFromMessage(message);
    const composeRecipients: string[] = getUniqueEmailAddressesFromComposeRecipients(recipients);

    return relativeComplementOfArrays(composeRecipients, messageRecipients);
}

function getUniqueEmailAddressesFromComposeRecipients(recipients: RecipientsCollection): string[] {
    const emailAddresses: string[] = [];

    recipients.toRecipients.forEach(recipient =>
        updateRecipientsList(emailAddresses, recipient.persona.EmailAddress.EmailAddress)
    );
    recipients.ccRecipients.forEach(recipient =>
        updateRecipientsList(emailAddresses, recipient.persona.EmailAddress.EmailAddress)
    );

    recipients.bccRecipients.forEach(recipient =>
        updateRecipientsList(emailAddresses, recipient.persona.EmailAddress.EmailAddress)
    );

    return emailAddresses;
}

function getUniqueEmailAddressesFromMessage(message: Message): string[] {
    const emailAddresses: string[] = [];

    if (message.ToRecipients) {
        message.ToRecipients.forEach(recipient =>
            updateRecipientsList(emailAddresses, recipient.EmailAddress)
        );
    }

    if (message.CcRecipients) {
        message.CcRecipients.forEach(recipient =>
            updateRecipientsList(emailAddresses, recipient.EmailAddress)
        );
    }

    if (message.BccRecipients) {
        message.BccRecipients.forEach(recipient =>
            updateRecipientsList(emailAddresses, recipient.EmailAddress)
        );
    }

    if (message.From) {
        updateRecipientsList(emailAddresses, message.From.Mailbox.EmailAddress);
    }

    return emailAddresses;
}

function updateRecipientsList(emailAddresses: string[], emailAddress: string) {
    if (!emailAddresses.includes(emailAddress)) {
        emailAddresses.push(emailAddress);
    }
}

function relativeComplementOfArrays<T>(arr1: T[], arr2: T[]): T[] {
    let result = arr1.filter(item => arr2.indexOf(item) === -1);

    // Removes the duplicates
    result = result.filter((item, index, arr) => arr.indexOf(item) === index);

    return result;
}
